var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telegram-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2.04361 14.5446C2.04361 14.5446 16.7861 7.959 21.8991 5.64007C23.8591 4.71257 30.506 1.74431 30.506 1.74431C30.506 1.74431 33.5739 0.445817 33.3182 3.59944C33.2329 4.89807 32.5512 9.443 31.8695 14.3591C30.8469 21.3158 29.7391 28.9216 29.7391 28.9216C29.7391 28.9216 29.5686 31.0551 28.12 31.4261C26.6713 31.7971 24.2851 30.1276 23.8591 29.7564C23.5182 29.4783 17.4678 25.3042 15.2522 23.2636C14.6557 22.7071 13.974 21.5941 15.3374 20.2954C18.4052 17.2345 22.0695 13.4316 24.2851 11.0199C25.3078 9.90681 26.3303 7.30969 22.0695 10.4633C16.0192 15.0084 10.054 19.2751 10.054 19.2751C10.054 19.2751 8.69049 20.2026 6.13401 19.3678C3.57742 18.5331 0.594831 17.42 0.594831 17.42C0.594831 17.42 -1.45025 16.0287 2.04361 14.5446Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.b9c6d392129bc7fc31012e5d04c82014.svg";
export { ForwardRef as ReactComponent };